/**
 * Coordinates all vocabulary words.
 */

interface VocabWord {
  id: number
  term: string
  definition: string
}

export default {
  state: {
    words: {},
    earnedWords: []
  },
  mutations: {
    VOCAB_ADD_WORD(state: any, payload: VocabWord) {
      state.words[payload.id] = payload
    },
    VOCAB_GET_WORD(state: any, id: number) {
      state.earnedWords.push(id)
    }
  },
  actions: {
  },
}
